import styled from 'styled-components';
import { colorCSS, cssColorsFromBackgroundField, fontSizes, maxWidth, minWidth } from '../../styles';
//style variables
const textColor = colorCSS('N0');
//styled components
export const Footer = styled.footer `
  ${cssColorsFromBackgroundField({ color: 'N800' })}

  section {
    color: ${textColor};

    span {
      font-size: ${fontSizes.sm};
    }

    svg {
      max-width: 125px;
    }

    a,
    button {
      color: ${textColor};
      text-decoration: none;
      &:hover {
        color: ${textColor};
        text-decoration: underline;
      }
    }

    ul {
      text-align: left;
      list-style-type: none;
      padding: 0;
    }

    @media ${maxWidth.lg} {
      form {
        margin-left: 1rem;
      }
    }
  }
`;
export const LogoAndLoginContainer = styled.div `
  margin: 1.5rem 1rem 0 1rem;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 1.75rem;

  a {
    padding: 0;
    margin: 0;
  }

  @media ${minWidth.lg} {
    flex-direction: column;
    align-items: stretch;
    margin: 1rem 1rem 0 0;
    gap: 1rem;
  }
`;
export const TabsList = styled.ul `
  margin: 0 0 0 1rem;

  h4,
  p {
    color: ${textColor};
    width: 60%;
    margin: 0;
    padding: 0;
  }

  div > p {
    color: ${textColor};
  }

  a {
    margin: 0;
    padding: 0;
  }

  li {
    border-bottom: 1px solid ${colorCSS('N400')};
    padding: 0 0 1rem 0;
    margin: 0 0 1rem 0;
  }

  li:first-child {
    border-top: 1px solid ${colorCSS('N400')};
    margin-top: 1rem;
    padding: 1rem 0 1rem 0;
  }

  li:last-child {
    margin: 0;
  }

  @media ${minWidth.lg} {
    display: flex;
    flex-wrap: wrap;
    margin: 0;

    h4,
    p {
      width: 100%;
    }

    a {
      padding: 1rem;
      gap: 0.25rem;
      height: 100%;
      &:hover {
        text-decoration: none !important;
        background-color: ${colorCSS('N600')};
      }
    }

    li {
      border: none;
      padding: 0;
      margin: 0;
      width: 25%;
    }

    li:first-child {
      border: none;
      padding: 0;
      margin: 0;
    }
  }
`;
export const Divider = styled.div `
  @media ${minWidth.lg} {
    border-top: 1px solid ${colorCSS('N400')};
    width: 98%;
    margin: 0 auto;
  }
`;
export const SubNav = styled.nav `
  ul {
    li {
      margin-left: 1rem;

      a,
      button,
      span {
        font-size: ${fontSizes.xxs};
      }
    }
  }

  @media ${minWidth.lg} {
    ul {
      display: flex;
      flex-wrap: nowrap;

      li {
        margin-right: 1.5rem;
        margin-left: 0;

        ${({ hideLanguageSelector }) => !hideLanguageSelector && '&:first-child { margin-left: 1rem }'};
      }
    }
  }
`;
export const SocialNavLinks = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin: 3rem 1rem 0 1rem;
  padding: 0 0 3rem 0;

  @media ${minWidth.lg} {
    justify-content: space-between;
    gap: 0;
    margin: 0;
    padding: 0;
  }

  a {
    align-items: center;
    border-radius: 50%;
    border: 2px solid ${textColor};
    display: flex;
    height: 24px;
    margin: 0 !important;
    width: 24px;
    svg {
      height: 60%;
      margin: auto !important;
      transition: all 0.15s;
      width: 60%;
      path {
        fill: ${textColor};
      }
    }
    &:hover {
      svg {
        height: 50%;
        width: 50%;
        path {
          fill: ${textColor};
        }
      }
    }
  }
`;
//# sourceMappingURL=UiFooterNav.styles.js.map